<template>
  <SmartFeed
    :source="useCollectionFeedStore"
    :default-feed-layout="getOptionValue(SmartFeedLayout)"
    :default-entity-size="getOptionValue(SmartFeedCardLayout)"
    :edit-mode="editMode"
  >
    <template #empty-state>
      <iStyledCard width="fill">
        <template #title>
          <iSpace :height="10" />
          <iSubHeading variant="subtle" font-size="large" align="center">
            {{ getOptionValue(EmptyStateText) }}
          </iSubHeading>
        </template>
      </iStyledCard>
    </template>
  </SmartFeed>
</template>

<script>
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { SmartFeedElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import { useCollectionFeedStore } from "SmartFeed/stores/feed/collection-feed-store";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";

export default {
  name: "Collections",
  components: {
    SmartFeed,
  },
  mixins: [
    DynamicElementMixin,
    SmartFeedElementMixin,
  ],
  elementPanelSettings: {
    displayName: "Collections",
    displayIcon: "feed",
    elementGroup: "collectionsElements",
    elementType: "element",
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new EmptyStateText({ "default": "No collections created yet." }),
  ],
  methods: {
    useCollectionFeedStore,
  },
};
</script>

<style scoped lang="scss">
</style>
